export enum CreditPromoStatus {

    Accepted = "Accepted",
    Rejected = "Rejected"
}
